import { ILang, LangTypeEnum } from '../src/modules/lang/types/Lang';
import { ApiUrlVersionEnum } from './base/api/axios/AxiosEnums';

export const appConfig = {
  defaultApiVersion: ApiUrlVersionEnum.v1,

  accessTokenStorageKey: '_MFAttachedDocumentsAccessToken', // _[projectName]AccessToken
  refreshTokenStorageKey: '_MFAttachedDocumentsRefreshToken', // _[projectName]RefreshToken

  // Debug
  sentrySettings: {
    dsn: 'https://668bd951225d79b7e1dbf365ed0ffde9@sentry.logicstars.ru/75',
  },

  // i18n
  langStorageKey: '_LSATLang', // _[projectName]Lang
  defaultLanguage: LangTypeEnum.RU,
  languages: [
    { title: 'Русский', lang: LangTypeEnum.RU },
    // { title: 'English', lang: LangType.EN },
  ] as ILang[],
};
